import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { WhatsappComponent } from './whatsapp/whatsapp.component';
import { SubirComponent } from './subir/subir.component';
import { CompatibleComponent } from './compatible/compatible.component';
import { InicioModule } from './inicio/inicio.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import localePy from '@angular/common/locales/es-PY';
import localeEn from '@angular/common/locales/en';
import localeESMX from '@angular/common/locales/es-MX';
import { registerLocaleData } from '@angular/common';
import {RecaptchaFormsModule, RecaptchaModule} from 'ng-recaptcha';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG} from '@ngx-translate/http-loader';
import { ChatbotComponent } from './chatbot/chatbot.component';

registerLocaleData(localePy, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeESMX, 'es-MX');
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    WhatsappComponent,
    SubirComponent,
    CompatibleComponent,
  ],
  imports: [
    ChatbotComponent,
    InicioModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      }
    })
  ],
  providers: [
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: {} },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: !localStorage.getItem('region') ? 'es-MX' : localStorage.getItem('region')}],
  bootstrap: [AppComponent]
})
export class AppModule { }
